import React, { FC } from 'react'
import { Heading2 } from 'is24-corecss'
import { useDispatch, useSelector } from 'react-redux'
import { StepTemplate } from '../../components/styled/stepTemplate/StepTemplate'
import './ResponseSolarStep.scss'
import { useReportViewEvent } from '../../hooks'
import { IntegrationType } from '../../@types/config'
import { ReduxState } from '../../store/reducers'
import { Button } from '../../components/styled/CosmaButton/CosmaButton'
import { reportTrackingEvent } from '../../tracking/thunks'

const tinyColor = require('tinycolor2')

export const ResponseSolarStep: FC = () => {
  useReportViewEvent({ pageTitle: 'response' })

  const { config } = useSelector((state: ReduxState) => state)
  const { theme, integrationType, illustration, flow } = config
  const dispatch = useDispatch()

  const handleSubmit = () => {
    dispatch(
      reportTrackingEvent({
        pageTitle: 'response',
        label: 'rle-promo_click',
        eventName: 'promotion_click',
        inputValue: 'homeowner_world',
        customDimensions: { ga_cd_lead_engine_input_value: 'homeowner_world' },
        action: 'solar-leadengine',
        category: 'lead',
        flow: flow,
      })
    )
    return (window.location.href = `https://www.immobilienscout24.de/meinkonto/meine-immobilien/?cmp_id=10-052145&cmp_name=homeowner_mein_eigentum&cmp_position=residential_sle_success&cmp_creative=success_screen_how_button`)
  }

  const StatusMessage = (
    <div className='margin-vertical-l'>
      <div className='status-message status-confirm response-message horizontal-center'>
        <div className='status-title padding-bottom-m' data-testid='status-headline'>
          Passende Anbieter wurden gefunden
        </div>
        <div data-testid='status-content'>
          Du erhältst die Vorschläge von uns per E-Mail. Falls du in deinem Posteingang nichts finden kannst, schau im
          Spam-Ordner nach.
        </div>
      </div>
    </div>
  )

  return (
    <StepTemplate
      headline={'Weitere Tipps zu deiner Immobilie'}
      displayNext={false}
      header={StatusMessage}
      className={'non-happy-path-response-step'}
      backgroundColor={theme.background}
      textColor={theme.text}
      primary={theme.primary}
      illus={illustration}
    >
      <div className='grid-flex grid-justify-center ' data-testing='response-container'>
        <div data-testid='response-sub-headline' className='padding-top-xl grid-item one-whole align-center'>
          <Heading2 className='heading-container'>
            <span>
              Mit unserem kostenlosen Bereich für <br className='palm-hide' /> Eigentümer hast du deine Immobilie{' '}
              <br className='palm-hide' /> immer im Blick.
            </span>
          </Heading2>
        </div>
        <div className='grid-item desk-one-half lap-two-thirds palm-one-whole justify-center details-holder margin-top-xl'>
          <ul data-testid='bullet-points' className={`list-check status-list horizontal-center`}>
            <li data-testid='bullet-point-1'>
              <span>
                Wert und Entwicklung deiner Immobilie inkl. <br className='palm-hide' /> Prognose
              </span>
            </li>
            <li data-testid='bullet-point-2'>
              <span>Empfehlungen zur Modernisierung</span>{' '}
            </li>
            <li data-testid='bullet-point-3'>
              <span>
                Bereit für den nächsten Schritt? Auf Wunsch in <br className='palm-hide' />
                Vermietung oder Verkauf starten.
              </span>
            </li>
          </ul>
        </div>
        <div className='grid-item one-whole desk-margin-top-m lap-margin-top-m palm-margin-top-xl padding-horizontal-l align-center'>
          <Button
            data-testid='response-step-unhappy-path-cta'
            onClick={handleSubmit}
            appearance='primary'
            className='palm-one-whole status-btn'
            primary={theme.primary}
            secondary={theme.secondary}
            textColor={
              integrationType === IntegrationType.EXTERNAL && tinyColor(theme?.primary).isDark()
                ? '#FFFFFF'
                : theme.text
            }
            secondaryLight={theme.secondaryLight}
          >
            Kostenlos anmelden
          </Button>
        </div>
      </div>
    </StepTemplate>
  )
}

export default ResponseSolarStep
